import Studios from './Studios';

export default Studios;
